import { render, staticRenderFns } from "./MatchTemplate.vue?vue&type=template&id=f8bd7de8&"
import script from "./MatchTemplate.vue?vue&type=script&lang=js&"
export * from "./MatchTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MatchTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports